'use client';

import '@kfonts/nanum-square-round' with { type: 'css' };

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface Props {
  fonts: string[];
}

export default function Home({ fonts }: Props) {
  const router = useRouter();
  useEffect(() => {
    const x = Math.floor(Math.random() * fonts.length);
    router.push(`/${fonts[x]}/`);
  }, [fonts, router]);
  return <main className='index'>순간이동 준비중….</main>;
}
